module.exports = __webpack_public_path__ + "static/media/iconosTarjeta.3f15626f.png";